import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { FeatureFlagHistoryResponse } from "./types";

export const FEATURE_FLAG_HISTORY_QUERY_KEY = ["admin", "feature-flag-history"] as const;

interface HistoryParams {
  readonly id: string;
  readonly limit: number;
  readonly offset: number;
}

async function fetchFeatureFlagHistory({
  id,
  limit,
  offset,
}: HistoryParams): Promise<FeatureFlagHistoryResponse> {
  const query = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  return httpClient<FeatureFlagHistoryResponse>(
    `/api/admin/feature-flags/${encodeURIComponent(id)}/history?${query.toString()}`,
  );
}

export function useFeatureFlagHistory(params: {
  readonly id: string | undefined;
  readonly limit: number;
  readonly offset: number;
}) {
  const { id, limit, offset } = params;
  return useQuery({
    queryKey: [...FEATURE_FLAG_HISTORY_QUERY_KEY, id ?? "", limit, offset] as const,
    queryFn: () => fetchFeatureFlagHistory({ id: id as string, limit, offset }),
    enabled: typeof id === "string" && id.length > 0,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
